import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import { Link } from "react-router-dom";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import Quibbler_HP5_HowFarWillFudgeGo from "assets/replicas/harry-potter/hp-quibbler/hp-quibbler-hp5-how-far-will-fudge-go";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import { routes } from "config";
import thumbnail from "./thumbnail.png";

let gallery = [];
let gallerySpecs = [];
let galleryFrogs = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  gallerySpecs = importAll(
    (require as any).context(
      "./gallery-spectrespecs",
      false,
      /\.(png|jpe?g|svg)$/
    )
  );
  galleryFrogs = importAll(
    (require as any).context("./gallery-frogs", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 2 },
          { index: 2, aspectRatio: 1 },
          { index: 7, aspectRatio: 2 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/ywBLWvKweHU"}
      />

      <ReplicaBigTitle title="Working Spectrespecs!" />

      <ReplicaQuote source="Harry Potter and the Half-Blood Prince">
        “Luna, hi, how are you?” “Very well, thank you,” said Luna. She was
        clutching a magazine to her chest; large letters on the front announced
        that there was a pair of free Spectrespecs inside. “Quibbler still going
        strong, then?” asked Harry, who felt a certain fondness for the
        magazine, having given it an exclusive interview the previous year. “Oh
        yes, circulation’s well up,” said Luna happily.
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        This issue of The Quibbler is the one with the most intricate cover.
        Aside from a lot of silver foiling, there are "working" (see-through)
        Spectrespecs that have actual transparent lenses just like the original
        prop, making the cover design more layered. The eyes on the cover are
        actually printed on the inner pages and visible through the lenses when
        closed - just like on the hero prop!
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(gallerySpecs)}
        imagesPerRow={3}
        imageOptions={[
          { index: 0, aspectRatio: 1.5 },
          { index: 1, aspectRatio: 1 },
        ]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <ReplicaBigTitle title="Moon Frogs" />

      <ReplicaQuote source="Harry Potter and the Order of the Phoenix">
        He flicked through the rest of the magazine. Pausing every few pages he
        read an accusation that the Tutshill Tornados were winning the Quidditch
        League by a combination of blackmail, illegal broom-tampering, and
        torture; an interview with a wizard who claimed to have flown to the
        moon on a Cleansweep Six and brought back a bag of moon frogs to prove
        it; and an article on ancient runes, which at least explained why Luna
        had been reading The Quibbler upside down.
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        A keen reader might notice that the quote above is actually from The
        Order of the Phoenix and refers to a completely different issue of The
        Quibbler. I specifically highlighted this because it marks the most
        significant clash between the books and the films. You see, according to
        the books, the{" "}
        <i>
          'interview with a wizard who claimed to have flown to the moon on a
          Cleansweep Six and brought back a bag of moon frogs to prove it'
        </i>{" "}
        is supposed to appear in the{" "}
        <Link
          to={
            "/" + routes.replicas.slug + "/" + Quibbler_HP5_HowFarWillFudgeGo.id
          }
          target="_blank"
        >
          'How Far Will Fudge Go To Gain Gringotts?'
        </Link>{" "}
        issue. However, this particular prop actually includes a designed page
        listing the featured articles — and one of them reads,{" "}
        <i>
          'I went to the moon & brought back a bag of moon frogs to prove it!'
        </i>
        , which is clearly meant to be the same article. I ultimately decided to
        go against the book (a rare occasion) in order to stay true to the
        actual designed page, so the article is featured in this issue instead.
        That specific page, however, didn’t exist, so I had to design it myself
        — along with the article.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryFrogs)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
